// Shared label scrub for UI telemetry — imported by BOTH the client logger
// (lib/ui-log.ts, which re-exports it) and the server ingest
// (app/api/ui-events/route.ts). Lives in its own plain module because server
// code must never import from a 'use client' module; one implementation
// guarantees the server re-scrub matches the client's.
//
// Scrub a DOM- or user-adjacent string down to a log-safe label: collapse
// whitespace, cap the length, and mask any token carrying two or more digits
// ("Post $1,234.56" → "Post #") so SSNs, DOBs, member IDs, phone numbers, and
// dollar amounts never reach the log. Heuristic by design — resident NAMES
// are not caught here; the components that render names carry code-authored
// data-track labels instead (accepted residual risk, ruled 2026-07-31).
export function scrubLabel(raw: unknown, max = 80): string | null {
  try {
    if (typeof raw !== 'string') return null
    const collapsed = raw.replace(/\s+/g, ' ').trim()
    if (!collapsed) return null
    const masked = collapsed
      .split(' ')
      .map((token) => {
        const digits = token.replace(/\D/g, '').length
        return digits >= 2 ? '#' : token
      })
      .join(' ')
    const capped = masked.length > max ? `${masked.slice(0, max - 1)}…` : masked
    return capped || null
  } catch {
    return null
  }
}
